<template>
    <PrimeButton :class="`custom-button ${computedClasses}`"
                 :disabled="disabled">
        <label v-if="label" for="custom-button" class="cursor-pointer">
            {{ label }}
        </label>
    </PrimeButton>
</template>

<script>
    import PrimeButton from "primevue/button";

    export default {
        name: "CustomButton",

        props: {
            label: {
                type: String,
                default: "",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            },
            secondary: {
                type: Boolean,
                default: false,
            },
        },

        components: {
            PrimeButton,
        },

        computed: {
            computedClasses() {
                let classes = "";
                if (this.secondary) classes += " secondary"
                return classes;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/theme/mytheme/variables";
    .custom-button {
        justify-content: center;
        border-radius: 40px;
        padding: 10px 20px;
        background-color: var(--primary-button-color);
        border: none;
        font-weight: 600;
        &.secondary {
            background-color: var(--secondary-button-color);
        }
        label {
            color: var(--background-color);
            text-transform: uppercase;
        }
        &:hover {
            opacity: 0.9;
        }
        @media screen and (max-width: 650px) {
            font-size: 12px;
            padding: 10px;
        }
    }
</style>
